<template>
  <div>
    <PreviewLayout :item="item" :loading="loading">
      <component
        :is="`h${headingTypeString}`"
        :class="`p-postEditor__heading${headingTypeString}`"
        v-html="previewContent(content)"
      >
      </component>
    </PreviewLayout>
  </div>
</template>

<script>
import baseTextlintPreview from '@/mixins/base_textlint_preview'
import PreviewLayout from './PreviewLayout'

export default {
  name: 'HeadingItemPreview',
  components: { PreviewLayout },
  mixins: [baseTextlintPreview],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    headingTypeString: function () {
      let headingTypeString = this.item.itemableAttributes.headingType
      if (typeof headingTypeString !== 'number') {
        headingTypeString = Number(headingTypeString)
          ? Number(headingTypeString)
          : 2
      }
      return headingTypeString
    },
    content: function () {
      return this.item.itemableAttributes.content
    }
  },
  mounted () {
    this.setLintAction(this.content)

    this.$store.subscribe((mutation) => {
      if (mutation.type === 'PostEditor/UPDATE_ITEM') {
        if (mutation.payload.uuid === this.item.uuid) {
          this.setLintAction(this.content)
          this.$store.commit('TextLintStore/deleteItemLintResult', {
            uuid: this.uuid
          })
          this.lintAction().call()
        }
      }
    })
  }
}
</script>
